const logo = $('.js-analitics-logo');
const plusBtn = $('.js-analitics-plus-btn');
const plusLink = $('.js-analitics-plus-link');
const letsGo = $('.js-analitics-go');

logo.on('click', () => {
  trackEvent('logo_click');
});

plusBtn.on('click', () => {
  trackEvent('shahid_plus_click');
});

plusLink.on('click', () => {
  trackEvent('shahid_plus_link');
});

letsGo.on('click', () => {
  trackEvent('shared_letsgo_click');
});

